import { render, staticRenderFns } from "./TimeAssignment.vue?vue&type=template&id=54509f06&scoped=true&"
import script from "./TimeAssignment.vue?vue&type=script&lang=ts&"
export * from "./TimeAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./TimeAssignment.vue?vue&type=style&index=0&id=54509f06&prod&lang=scss&scoped=true&"
import style1 from "./TimeAssignment.vue?vue&type=style&index=1&id=54509f06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54509f06",
  null
  
)

export default component.exports